export const RoutesConfig = {
    HOME: "/",
    BOOK: "/book/:id",
    NOT_FOUND: "*",
    BOOK_CARD: "/Book",
    FAVORITES: "/Favorites"
};
